import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../../api-config";

const PostDetail = () => {
  const { id } = useParams(); // Obtener el ID del post desde los parámetros de la URL
  const [post, setPost] = useState(null); // Estado para almacenar el post
  const [loading, setLoading] = useState(true); // Estado de carga
  const [error, setError] = useState(null); // Estado para manejar errores

  // Función para obtener los detalles del post
  const fetchPost = async () => {
    try {
      const response = await axios.get(`${API_URL}/trading-api/charts/post/${id}`);
      setPost(response.data); // Guarda los datos del post
    } catch (err) {
      setError("Error al cargar los detalles del post.");
      console.error(err);
    } finally {
      setLoading(false); // Desactiva el estado de carga
    }
  };

  // Hook para cargar los detalles al montar el componente
  useEffect(() => {
    fetchPost();
  }, [id]);

  if (loading) {
    return <p className="text-center">Cargando detalles del post...</p>;
  }

  if (error) {
    return <p className="text-center text-red-500">{error}</p>;
  }

  return (
    <div className="flex inset-0 bg-opacity-50 flex h-fit items-center justify-center">
      <div className="bg-gray-800 w-4/5 h-4/5 rounded-lg shadow-lg overflow-hidden pt-8">

        {post && (
          <div className="grid grid-cols-2 gap-4 p-6 h-[calc(100%-4rem)]">
            {/* Sección Izquierda - Imágenes */}
            <div className="flex flex-col gap-4">
              {/* Imagen 1 */}
              <div>

                <img
                  src={post.image_url_1}
                  alt="Imagen 1"
                  className="w-full h-fit object-cover rounded-lg border"
                />
              </div>
              {/* Imagen 2 */}
              <div>

                <img
                  src={post.image_url_2}
                  alt="Imagen 2"
                  className="w-full h-fit object-cover rounded-lg border"
                />
              </div>
            </div>

            {/* Sección Derecha - Textos */}
            <div className="flex flex-col gap-4 text-white justify-evenly">
              {/* Texto 1 */}
              <div>
                {/* <label className="block text-sm font-medium mb-2">Texto 1</label> */}
                <div className="w-full border rounded-lg p-4 bg-gray-700">
                  {post.text_1}
                </div>
              </div>
              {/* Texto 2 */}
              <div>
                {/* <label className="block text-sm font-medium mb-2">Texto 2</label> */}
                <div className="w-full border rounded-lg p-4 bg-gray-700">
                  {post.text_2}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PostDetail;
